import './index.scss'
import { Loading, InlineLoading } from 'carbon-components-react'
Loading.Inline = InlineLoading
export { Loading, InlineLoading, Loading as default }
